import React, { Component } from 'react';
import { Container, Spinner, Badge, Button, Form } from 'react-bootstrap'
import MessageBox from '../components/MessageBox';
import * as G from '../components/global'
import '../styles/glob.css'
import history from '../components/history';
import { translateScreen as ts , translateScreen2 as ts2 , translateDate as td} from '../components/dictionary'
import { connect } from 'react-redux';
import qs from 'qs'

class Rankings extends Component {

	constructor(props) {
		super(props);

		this.state = {
				list:[],
				listloading:false,
				updateMode:false,
				fields: {},
				modalShow: false,
				modalSubject: 'Delete ranking',
				modalBody: 'Are you sure you want to delete this ranking',
				justinfo: true,
				errors: {},
				deleteID: -1,
                languagesList:[],
                imagelink:'',
                selectedFile:null,
                fieldchanging:false,
                successmodalShow:false
		}
		this.handleChange = this.handleChange.bind(this);
        this.imagechangeHandler = this.imagechangeHandler.bind(this);
        this.handleLanguageChange = this.handleLanguageChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
	}
    getSnapshotBeforeUpdate(prevProps) {
        
        return { notifyRequired: prevProps.userLogin !== this.props.userLogin };
      }
      
      async componentDidUpdate(prevProps, prevState, snapshot) {
        if (snapshot.notifyRequired) {
            await this.loadData();
        }
        
      }
	componentDidMount(){
        this.getlanguages();
        if(this.props.userLogin.site)
		    this.loadData();
		history.listen((location, action) => {
            if(location.pathname == "/Rankings" || location.pathname == "/Rankings/")
            {
            this.setState({ updateMode: false });
            if(this.props.userLogin.site)
                this.loadData();
            }
            if(location.pathname == "/Rankings/create" || location.pathname == "/Rankings/create/")
            this.setState({ updateMode: true, fields: {} });
          });
          if(history.location.pathname == "/Rankings/create" || history.location.pathname == "/Rankings/create/")
            this.setState({ updateMode: true, fields: {} });
	}
    getlanguages = async()=>{
		let array = [];
		array = await G.getData("languages/query",[["filter"," 1=1 order by orderindex"]]);
		array = await array.data;
		this.setState({languagesList: array});
	}
	loadData = async ()=>{
		this.setState({listloading:true})
		var results = await G.getData("ranking/query",[["filter","siteid=" + this.props.userLogin.site.id]]);
		results = await results.data;
		this.setState({list:results, listloading:false});
        var qid = qs.parse(history.location.search, { ignoreQueryPrefix: true }).id
        
		this.loadDataTables();
        results.map((el)=>{
            if(qid == el.id)
            {
                this.openEdit(el, false);
            }
        })
	}
	loadDataTables = ()=>{
		
            try{
            if(document.getElementById("dttablestats")!=null)
            {
                document.getElementById("dttablestats").remove();
            }
        }
        catch(e){}
                const script = document.createElement("script");
            script.id = "dttablestats";
            script.src = '/dist/js/dttable.js';
            script.async = true;
            document.body.appendChild(script);
            
            this.setState({ listloading: false })
	}
	handleChange(e) {
       let { fields, errors } = this.state;
        fields[e.target.name] = e.target.value;
        delete errors[e.target.name];

        this.setState({ fields });
    }
    onBlur(e){
        this.setState({fieldchanging:false});
    }
    handleLanguageChange(e) {
		let { fields, errors,languagesList } = this.state;
		 fields[e.target.name] = e.target.value;
		 delete errors[e.target.name];

         for(var i=0;i<languagesList.length;i++)
         {
             var elem = languagesList[i];
             
             if(e.target.name.includes('_name'))
             {
                if(!fields[elem.id + "_name"] || fields[elem.id + "_name"]=='' || this.state.fieldchanging)
                {
                fields[elem.id + "_name"] = e.target.value;
                delete errors[elem.id + "_name"];
                this.setState({fieldchanging:true});
                }
             }
             if(e.target.name.includes('_description'))
             {
                if(!fields[elem.id + "_description"] || fields[elem.id + "_description"]=='' || this.state.fieldchanging)
                {
                    fields[elem.id + "_description"] = e.target.value;
                    document.getElementById(elem.id + "_description").value = e.target.value;
                    delete errors[elem.id + "_description"];
                    this.setState({fieldchanging:true});
                }
             }
         }
		 this.setState({ fields });
	 }
    imagechangeHandler(event) {
        var file = event.target.files[0];
        let reader = new FileReader();
    reader.onload = (e) => {
      this.setState({imagelink: e.target.result});
    };
    reader.readAsDataURL(file);
        
        this.setState({selectedFile:file});
	}
    openEdit = async(item, redirect = true)=>{
        let record = { ...item }
        //record.creationdate = dateFormat(item.creationDate, "dddd, mmm dd yyyy h:MM tt")
        var fields = this.state.fields;
        fields["frompoint"] = item.frompoint || '0';
        fields["topoint"] = item.topoint;        
        fields["appprimarycolor"] = item.appprimarycolor;
        fields["appsecondarycolor"] = item.appsecondarycolor;
        fields["appbuttoncolor"] = item.appbuttoncolor;
        var dres = await G.getData("rankingtranslation/query",[["filter","rankingid="+item.id]])
            dres = await dres.data
            for(var i=0;i<dres.length;i++)
            {
                var elem = dres[i];
                fields[elem.languageid + "_name"] = elem.name;
                fields[elem.languageid + "_description"] = elem.description;
            }
        
        fields["id"] = item.id
        this.setState({ updateMode: true, imagelink:G.nodeServerSite+"mediaFiles/rankingicon/" + item.icon, fields:fields });
        if(redirect == true)
            history.push("/Rankings/edit?id=" + item.id)
    }
	render() {
		const { errors, fields } = this.state;
        var clientslug = this.props.userLogin.site && this.props.userLogin.site.slug;
        //if (this.props.userLogin.language)language=this.props.userLogin.language;
		return (
			<>
			{!this.state.updateMode && <div>
			<section className='content-header'>
                    <div className='container-fluid'>
                    <div className='row mb-2'>
                <div className='col-sm-6'>
                    <h1 className=''>{ts('Ranking',this.props.userLogin.language)} </h1>
                    </div>
                    </div>
                    </div>
                    </section>
					<section className='content'>
                        <div className='row'>
                    <Button variant='success mt-3 mb-5 ml-3' onClick={() => { this.setState({ updateMode: true, fields: {} });history.push("/Rankings/create") }}>{ts2('Create New ranking',this.props.userLogin.language)}</Button>
                    </div>
                    <div className='row'>
                    <div className='col-md-12 '>
                        <div className="">
                        {!this.state.loadList && <table id="example1" className="table table-bordered">
                                <thead>
                                    <tr>
                                    <th>{ts2('Action',this.props.userLogin.language)}</th>
                                        <th>{ts2('Image',this.props.userLogin.language)}</th>
                                        <th>{ts2('Name',this.props.userLogin.language)}</th>
                                        <th>{ts2('Points range',this.props.userLogin.language)}</th>
                                        

                                    </tr>
                                </thead>
{!this.state.listloading && 

                                <tbody>
                                    {
                                        (this.state.list).map((item) => {
                                            
                                            /*this.state.clientsList.filter(val => val.key == item.clientID).map(filteredName => (
                                                clientslug = filteredName.clientslug 
                                            ))*/
                                            return (
                                                <tr key={item.id}>
                                                    <td className='xxxtitle whiteColor handCursor'
                                                        >
                                                        <Button onClick={async() => {
                                                            this.openEdit(item);
                                                            
                                                        }} className="btn btn-primary" style={{width:"150px"}}>{ts2('View',this.props.userLogin.language)}</Button><br/>
														<Button onClick={() => {
                                                                
                                                                
                                                                    this.setState({
                                                                        modalShow: true,
                                                                        modalSubject: ts2('Delete ranking',this.props.userLogin.language),
                                                                        modalBody: ts2('Are you sure you want to delete this ranking?',this.props.userLogin.language),
                                                                        justinfo: false,
                                                                        deleteID: item.id
                                                                    })
                                                                

                                                        }} className="btn btn-danger" style={{width:"150px", marginTop:"10px"}}>{ts2('Delete',this.props.userLogin.language)}</Button>
                                                    </td>
													<td><img src={G.nodeServerSite+"mediaFiles/rankingicon/" + item.icon} style={{width:"100px", maxWidth:"100%"}}/></td>
                                                    <td>{item.name}</td>
                                                    <td>{item.frompoint} - {item.topoint}</td>
                                                    
                                                 

                                                </tr>)
                                        })
                                    }

                                </tbody>
    }
                            </table>}
                            {this.state.loadList &&
                                <div className='flexcolumn center verticalcenter p-5 fullWidth hint '>
                                   {ts2('Loading rankings',this.props.userLogin.language)} 
                                    <Spinner animation="border" className='mt-3' variant="warning" />

                                </div>
                            }
                        </div>
                    </div>
                    </div>
                    </section>
					</div>}
					{
                    this.state.updateMode && <>
                    
                        <section className='content'>
                        <div className='row'>
							<div className='col-md-12'>
							<Button className='mb-4 mt-5' variant='warning' onClick={() => { this.setState({updateMode:false, fields:{}});history.go(-1) }} >{ts('Cancel / Return', this.props.userLogin.language)}</Button>
							</div>
							<div className='col-md-12'>
							<h3>{ts('Ranking details',this.props.userLogin.language)}
                            </h3>
							</div>
							
							<div className='col-md-12' style={{height:"20px"}}></div>
							<div class="col-12 col-sm-6">
<div class="card card-primary card-outline card-tabs">
<div class="card-header p-0 pt-1 border-bottom-0">
<ul class="nav nav-tabs" id="custom-tabs-two-tab" role="tablist">
<li class="pt-2 px-3"><h6 class="card-title" style={{margin:"0px"}}>Entry by language</h6></li>
{
	this.state.languagesList.map((elem)=>{
		return <li class="nav-item">
<a class={elem.code == "fr"?"nav-link active":"nav-link"} id={"custom-tabs-two-" + elem.code + "-tab"} data-toggle="pill" href={"#custom-tabs-two-" + elem.code} role="tab" aria-controls={"custom-tabs-two-" + elem.code} aria-selected="true">{elem.code}</a>
</li>
	})
}
</ul>
</div>
<div class="card-body">
<div class="tab-content" id="custom-tabs-two-tabContent">
	{
		this.state.languagesList.map((elem)=>{
			return <div class={elem.code == "fr"?"tab-pane fade show active":"tab-pane fade"} id={"custom-tabs-two-" + elem.code} role="tabpanel" aria-labelledby={"custom-tabs-two-"+elem.code+"-tab"}>
				{G.renderTextField("Title", 'text', "enter ranking title here", (elem.code == "fr"?this.handleLanguageChange:this.handleChange), fields, errors, null, '',false, this.props.userLogin.language, true,elem.id + "_name",this.onBlur)}
				{G.renderTextArea("Description", 'textarea', "enter ranking description here", (elem.code == "fr"?this.handleLanguageChange:this.handleChange), fields, errors, null, '',false, this.props.userLogin.language, true,elem.id + "_description",this.onBlur)}
			</div>
		})
	}

</div>
</div>

</div>
</div>
<div className='col-md-12' style={{height:"20px"}}></div>
<div class='col-md-4'>
{G.renderTextField("App primary color", 'color', "App primary color", this.handleChange, fields, errors, null, '',false, this.props.userLogin.language, true,"appprimarycolor",this.onBlur)}
</div>
<div className='col-md-12' style={{height:"20px"}}></div>
<div class='col-md-4'>
{G.renderTextField("App secondary color", 'color', "App secondary color", this.handleChange, fields, errors, null, '',false, this.props.userLogin.language, true,"appsecondarycolor",this.onBlur)}
</div>
<div className='col-md-12' style={{height:"20px"}}></div>
<div class='col-md-4'>
{G.renderTextField("App button color", 'color', "App button color", this.handleChange, fields, errors, null, '',false, this.props.userLogin.language, true,"appbuttoncolor",this.onBlur)}
</div>
<div className='col-md-12' style={{height:"20px"}}></div>
<div class='col-md-4'>
<div class="form-group">
 <label for="icon">Image</label>
<div class="input-group">
<div class="custom-file">
<input type="file" onChange={this.imagechangeHandler} class="custom-file-input" id="icon" name="icon"/>
<label class="custom-file-label" for="exampleInputFile">Choose file</label>
</div>
</div>





</div>
{this.state.imagelink && <img src={this.state.imagelink} style={{width:"150px"}}/>}
</div>
<div className='col-md-12' style={{height:"20px"}}></div>
<div className='col-md-6'>
<label>Point range</label>
<table><tr>
    <td>From</td><td style={{width:"5px"}}></td><td><input type="number" id="frompoint" name="frompoint" value={this.state.fields["frompoint"]|| ''} onChange={this.handleChange} class="form-control"/></td>
    <td style={{width:"20px"}}></td>
    <td>To</td><td style={{width:"5px"}}></td><td><input type="number" id="topoint" name="topoint" value={this.state.fields["topoint"]|| ''} onChange={this.handleChange} class="form-control"/></td>
</tr>
<tr>
<td></td><td style={{width:"5px"}}></td><td>{errors["frompoint"] && <div className='remarks notValidColor'>{errors["frompoint"]}</div>}</td>
    <td style={{width:"20px"}}></td>
    <td></td><td style={{width:"5px"}}></td><td>{errors["topoint"] && <div className='remarks notValidColor'>{errors["topoint"]}</div>}</td>
</tr>
</table>
</div>
</div>
                        <div className='row'>
                           <div className='col-md-12'>
                        <Button variant='success ml-3 mt-5' onClick={() => {   fields.id==undefined || fields.id == null ? this.updateranking(-1) : this.updateranking(fields.id) }}>{ts2('Save',this.props.userLogin.language)}</Button>
                        <Button variant='warning ml-3 mt-5' onClick={() => { this.setState({ updateMode: false });history.go(-1);
                        
                        this.loadDataTables();
                    }}>{ts('Cancel',this.props.userLogin.language)}</Button>
                   </div> </div>
                <div className='row'>
                
                </div>
                </section>
                
                </>
    }
	<MessageBox
                    show={this.state.modalShow}
                    title={this.state.modalSubject}
                    body={this.state.modalBody}
                    onHide={() => { this.setState({ modalShow: false }) }}
                    middle={!this.state.justinfo && {
                        action: () => {
                            this.deleteranking()


                        }, text: ts2('Delete ranking',this.props.userLogin.language), variant: 'danger'
                    }}
                    right={{ action: () => { this.setState({ modalShow: false }) }, text: this.state.justinfo ? 'OK' : ts('Cancel',this.props.userLogin.language), variant: 'success' }}


                />
                <MessageBox
                    show={this.state.successmodalShow}
                    title={ts("Changes are saved",this.props.userLogin.language)}
                    body={<div><center><Button variant="success" onClick={()=>{this.setState({ successmodalShow: false });}}>OK</Button></center></div>}
                    onHide={() => { this.setState({ modalShow: false }) }}

                />
			</>
		)
	}
    
	updateranking = async (recordID) => {
        let errors = {};
        console.log("recordID=", recordID)
        let parameters = [];
        let formIsValid = true;
        this.state.languagesList.map((elem)=>{
            var name = this.state.fields[elem.id + "_name"]
            var description = this.state.fields[elem.id + "_description"]
            if(name == undefined || name == '')
            {
                formIsValid = false;
                errors[elem.id + '_name'] = 'This field is required';
            }
            if(description == undefined || description == '')
            {
                formIsValid = false;
                errors[elem.id + '_description'] = 'This field is required';
            }
            if(elem.code == "en")
            {
                this.state.fields["name"] = name;
                this.state.fields["description"] = description;
            }
            parameters.push(["name_" + elem.code,name]);
            parameters.push(["description_" + elem.code,description]);
        });
        
        
        
        var {name, description, frompoint, topoint, appprimarycolor, appsecondarycolor, appbuttoncolor} = this.state.fields; 
        if (!name) { formIsValid = false; errors["name"] = "ranking Name cannot be empty"; }
        if(!frompoint){formIsValid = false; errors["frompoint"] = "From range cannot be empty";}
        if(!topoint){formIsValid = false; errors["topoint"] = "To range cannot be empty";}
        if(parseInt(frompoint)>parseInt(topoint)){
            formIsValid = false; 
            errors["topoint"] = "From range cannot be greater then to range";
            errors["frompoint"] = "From range cannot be greater then to range";
            
        }
        this.setState({errors})
        if (formIsValid) {
            parameters.push(["name" ,name]);
            parameters.push(['description' ,description]);
            parameters.push(['icon' ,this.state.selectedFile]);
            parameters.push(['rankingId' , recordID]);
            parameters.push(['frompoint' ,frompoint]);
            parameters.push(['topoint' , topoint]);
            parameters.push(['siteid' ,this.props.userLogin.site.id]);
            parameters.push(['appprimarycolor' ,appprimarycolor]);
            parameters.push(['appsecondarycolor' ,appsecondarycolor]);
            parameters.push(['appbuttoncolor' ,appbuttoncolor]);
           //parameters.push(['clientID', this.props.userLogin.site.id])
            let result = await G.uploadData('ranking/upload', parameters)
            console.log(result)
            let success = (result.status === 200)
            if (success) {
                this.setState({ updateMode: false, fields: {}, successmodalShow: recordID!==-1})
                if(recordID === -1)
                {
                    var logtxt = this.props.userLogin.username + " has created a ranking " + name;
                    await G.SaveUserLog(logtxt, this.props.userLogin.id);
                }
                else{
                    var logtxt = this.props.userLogin.username + " has edited the ranking info of " + name;
                    await G.SaveUserLog(logtxt, this.props.userLogin.id);
                }
                this.loadData()
                history.push("/Rankings")
            }
            else if(result.status === 601){
                errors["topoint"] = "This value cause a conflict please change it.";
                errors["frompoint"] = "This value cause a conflict please change it.";
            formIsValid = false;
            this.setState({errors})
            }
        }
    }
	deleteranking =async () => {
		let parameters = [['filter', "id=" + this.state.deleteID]]
		var result = await G.getData('ranking/delete', parameters, true)
		result = await result.status;
		if (result === 200) {
			this.setState({ deleteID: -1, modalShow:false })
			//this.loadData()
			window.location.reload();
		}else{
			this.setState({
				modalShow: true,
				modalSubject: 'Error Appeared',
				modalBody: 'Problem Occured while hiding Record. Please Try Again',
				justinfo: true
			})
		}
	}
}


const mapStateToProps = state => {
    return {
        userLogin: state.SaveLogin.userData
    };
};

export default connect(
    mapStateToProps
)(Rankings);